import dayjs from 'dayjs';
import { generateUniqueId } from 'utils/hooks/generateUniqueId';

const dateFormat = 'YYYY-MM-DD';

const newTaskObj = (solId: number) => ({
  tsk_id: generateUniqueId(),
  tsk_short_name: '',
  tsk_desc: '',
  tsk_tkt_ref: '',
  tsk_tst_ref: '',
  tsk_owner: '',
  tsk_due_date: dayjs().format(dateFormat).toString(),
  tsk_sol_ref: solId
});

export default newTaskObj;
